export default __webpack_public_path__ + "static/media/img-ln-2-big-bg.ca55d0d7.png";